import React from 'react';
import styled, { css } from 'styled-components';
import { theme as fromTheme } from 'styled-tools';

import { Section, Heading } from 'components/Common';
import { typography, colorScale, maxWidth, minWidth } from 'themes';

import {
  CollaborationSection,
  PartneringBanksSection,
  PartneringInsurersSection,
  PartneringSgxCdpSection,
} from '../partners';

const Wrapper = styled(Section)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const StyledHeader = styled(Heading)`
  ${typography('heading-l')};
  margin: 32px 0 16px;
`;

const SubSection = styled(Section)`
  background: white;
  padding: 24px 16px;
  border: 1px solid ${colorScale('grey', 20)};

  ${maxWidth(
    'tablet',
    css`
      width: 100vw;
      border-left: none;
      border-right: none;
      margin: 8px -16px;
    `
  )}

  ${minWidth(
    'desktop',
    css`
      width: 100%;
      margin: 8px 0;
      border-radius: ${fromTheme('borders.radiusLarge')};
    `
  )}
`;

const ListSubHeader = styled(Heading)`
  ${typography('heading-m')};
  margin-bottom: 16px;
`;

const List = styled.ul`
  padding-inline-start: 24px;
`;

const ListItem = styled.li`
  margin-bottom: 8px;
`;

const PartnersSectionWrapper = styled.div`
  margin: 24px 0;
  width: 100%;
`;

export const SGFinDexDataListPageContent = () => (
  <Wrapper>
    <StyledHeader>Data you can retrieve with SGFinDex</StyledHeader>

    <SubSection>
      <ListSubHeader>Government data</ListSubHeader>
      <List>
        <ListItem>Latest CPF account balances</ListItem>
        <ListItem>Past year’s tax bill (Notice of Assessment)</ListItem>
        <ListItem>Outstanding HDB loan balances and monthly instalments</ListItem>
        {/* <ListItem>Dependants’ Protection Scheme (DPS)</ListItem>
        <ListItem>Home Protection Scheme (HPS)</ListItem>
        <ListItem>MediShield Life</ListItem> */}
      </List>
    </SubSection>

    <SubSection>
      <ListSubHeader>Bank data</ListSubHeader>
      <List>
        <ListItem>Past months’ current and savings account balances</ListItem>
        <ListItem>Past months’ credit card statements</ListItem>
        <ListItem>Loans</ListItem>
        <ListItem>Fixed deposits</ListItem>
        <ListItem>Unit Trusts</ListItem>
        <ListItem>Supplementary Retirement Scheme (SRS) account</ListItem>
        <ListItem>CPF Investment Scheme (CPFIS) acount</ListItem>
      </List>
    </SubSection>

    <SubSection>
      <ListSubHeader>Central Depository (CDP) data</ListSubHeader>
      Investments in SGX CDP accounts, including:
      <List>
        <ListItem>Equities</ListItem>
        <ListItem>Bonds</ListItem>
        <ListItem>Funds</ListItem>
        <ListItem>Structured products</ListItem>
      </List>
    </SubSection>

    <SubSection>
      <ListSubHeader>Insurance data</ListSubHeader>
      Individual life and health insurance information, pertaining to:
      <List>
        <ListItem>Policy details</ListItem>
        <ListItem>Coverage details</ListItem>
        <ListItem>Fund details (where applicable)</ListItem>
        <ListItem>Projected future policy value (where applicable)</ListItem>
      </List>
    </SubSection>

    <PartnersSectionWrapper>
      <PartneringBanksSection />
      <PartneringSgxCdpSection />
      <PartneringInsurersSection />
      <CollaborationSection />
    </PartnersSectionWrapper>
  </Wrapper>
);
